import store from '@/store';
import { DateTime } from 'luxon';

export function setTimeAsStoreDateTime(value) {
    const dateTime = DateTime.fromISO(`${DateTime.now().toISODate()}T${value}`);

    return dateTime.setZone(store.getters.getTimeZone, {
        keepLocalTime: true
    }).toISO();
}

export function convertToStoreTimeZone(value) {
    return value.setZone(store.getters.getTimeZone);
}

export function convertISOStringToStoreTimeZone(value) {
    const dateTime = DateTime.fromISO(value, { setZone: true });

    return convertToStoreTimeZone(dateTime);
}

export function convertToUTC(value) {
    return value.toUTC();
}

export function convertISOStringToUTC(value) {
    const dateTime = DateTime.fromISO(value, { setZone: true });

    return convertToUTC(dateTime);
}
